// extracted by mini-css-extract-plugin
export default {"statsContainer":"Stats_statsContainer__+6vwC","statsCard":"Stats_statsCard__zRFdm","trader":"Stats_trader__v7saK"};